module.exports = __webpack_public_path__ + "static/media/frank-x.618168f8.md";